import React, { Component } from 'react'
import Box from "@mui/material/Box";
import  BreadCrumb  from  "../../components/BreadCrumb"
import FormsTable from "./components/FormsTable/index"
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectformData, selectIsLoading } from "./redux/selector"
import { useStyles } from "./styles";
import { useInjectReducer } from "redux-injectors";
import { reducer, sliceKey } from "./redux/slice";
import { AddButton } from 'app/components/Button/AddButton';




export const Forms = () => {

  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const rows = useSelector(selectformData)
  const loading = useSelector(selectIsLoading)
  
  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <BreadCrumb title={t("SIDEBAR.BOOKS")} iconPosition="end" />
        <Box>
          <AddButton label={t(("BOOKS.ADD"))}/>
        </Box>
        <FormsTable rows={rows} loading={loading} />
      </Box>
    </Box>
  )
}

export default Forms